import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import BannerImg from "../../images/referral-program/referral-banner.png";

function Banner(props) {
    return (
        <div className="referral services_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Referral">
                                <h1>The Highest Paying App Development Referral Program</h1>
                            </div>
                            <div className="banner_content_txt listing_flex">
                                <p><strong>By becoming our partner in our referral program, you can gain incredible commissions on a consistent basis.</strong></p>
                                <div className="ref-div">
                                    <h4>Our Last Referral Partner Earned</h4> <span className="ref-num">$7,300</span>
                                </div>
                                <p><strong>He Joined The Program Just 15 Days Ago!</strong></p>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
                        <div className="ref-banner-img">
                            <LazyLoadImage
                                src={BannerImg}
                                effect="blur" alt="latest-events" className="img-fluid"
                            />
                        </div>

                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;